import { Navigate, useLocation } from 'react-router-dom';

import { useWebCoreStore } from '@codes/web-core';

import { AuthPathRoute } from './AuthPathRoute';
import { savePendingRedirect } from '../../shared/hooks/usePendingRedirect';

interface AuthGuardProps {
    children: React.ReactNode;
    redirectTo?: string;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children, redirectTo = '/auth/login' }) => {
    const isAuthenticated = useWebCoreStore(state => state.isAuthenticated);
    const location = useLocation();

    if (!isAuthenticated) {
        const fullPath = location.pathname + location.search;

        // Save callback URLs (like from Flow) before redirect
        // This runs synchronously before Navigate, ensuring the URL is preserved
        if (fullPath.includes('callback=flow')) {
            savePendingRedirect(fullPath, true);
        }

        return <Navigate to={redirectTo} state={{ from: fullPath }} replace />;
    }

    return <AuthPathRoute>{children}</AuthPathRoute>;
};
